import { render, staticRenderFns } from "./wechatPay.vue?vue&type=template&id=5c1ad467"
import script from "./wechatPay.vue?vue&type=script&lang=js"
export * from "./wechatPay.vue?vue&type=script&lang=js"
import style0 from "./wechatPay.vue?vue&type=style&index=0&id=5c1ad467&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports